import { Button, ButtonGroup, Spinner } from "@shopify/polaris"
import { DesktopIcon, MobileIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import { observer } from "mobx-react"
import { useState } from "react"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"
import stores from "@/stores"

import styles from "./index.module.scss"
import ThemeLayoutRight from "./ThemeLayoutRight"

export interface ThemeLayoutRightLayoutProps {
  variant: ThemeLayoutEnum
}

/**
 * 右侧预览区（结构对齐 Email Edit 的 RightLayout：分段切换 + 预览主体）。
 */
const RightLayout = observer(({ variant }: ThemeLayoutRightLayoutProps) => {
  const [selected, setSelected] = useState(0)
  const previewLoading = stores.themeLayoutConfigStore.loading

  const tabs = [
    {
      icon: DesktopIcon,
      children: <ThemeLayoutRight variant={variant} viewport="desktop" />,
    },
    {
      icon: MobileIcon,
      children: <ThemeLayoutRight variant={variant} viewport="mobile" />,
    },
  ]

  return (
    <div className={styles.rightTabWrapper}>
      <div className={classNames(styles.contentTabContainer)}>
        <ButtonGroup gap="loose" variant="segmented">
          {tabs.map((item, index) => (
            <Button
              key={index}
              icon={item.icon}
              pressed={index === selected}
              size="large"
              onClick={() => setSelected(index)}
            />
          ))}
        </ButtonGroup>
      </div>
      <div className={styles.contentMainHost}>
        <div className={styles.contentMain}>
          <div className={styles.contentMainScroll}>
            <div className={styles.contentMainInner}>{tabs[selected].children}</div>
          </div>
        </div>
        {previewLoading ? (
          <div
            aria-busy
            aria-live="polite"
            className={styles.previewLoadingOverlay}
          >
            <Spinner accessibilityLabel="Loading preview" hasFocusableParent={false} />
          </div>
        ) : null}
      </div>
    </div>
  )
})

export default RightLayout
